import { render, staticRenderFns } from "./ti4.vue?vue&type=template&id=9d428c70&scoped=true&"
import script from "./ti4.vue?vue&type=script&lang=js&"
export * from "./ti4.vue?vue&type=script&lang=js&"
import style0 from "./ti4.vue?vue&type=style&index=0&id=9d428c70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d428c70",
  null
  
)

export default component.exports